import { currentCameraCheck, currentSpeackerCheck } from '@stores/atoms/device';
import { atom } from 'jotai';

export const isSpeakerChecked = atom((get) => {
  return get(currentSpeackerCheck) ?? false;
});

export const isCameraChecked = atom((get) => {
  return get(currentCameraCheck) ?? false;
});
